export default __webpack_public_path__ + "static/media/Mastercard.18fbdfc3.png";